import { get, set } from "@ember/object"
import Service, { inject as service } from "@ember/service"
import { analytics } from "cc-frontend/error-handling"
import findDocument from "cc-frontend/helpers/find-document"

export default class InAppNoticeService extends Service {
  isVisible = false
  contentfulEntryId = null

  // For testing:
  // isVisible: true,
  // contentfulEntryId: "2tka6oSZuAmS64cus4CySU",

  notice = null

  campaignId = null

  @service("ember-store")
  store

  @findDocument("contentfulEntryId", "in-app-message")
  contentfulEntry

  newNotice(notice) {
    set(this, "contentfulEntryId", notice.attributes.contentfulEntryId)
    set(this, "notice", notice)
    if (get(this, "isVisible") === false) {
      set(this, "isVisible", true)
    }
    analytics.track("In App Notice - Received", {
      campaignId: notice.attributes.campaignId,
      contentfulEntryName: get(this, "contentfulEntry.attributes.name"),
      contentfulEntryId: notice.attributes.contentfulEntryId,
    })
  }

  close() {
    set(this, "isVisible", false)
  }

  replyAndClose() {
    let notice = get(this, "notice")
    set(this, "isVisible", false)
    console.log("notice", notice)
    if (window && window.Intercom) {
      window.Intercom("showNewMessage", get(this, "contentfulEntry.attributes.intercomMessageSeed"))
    }
    analytics.track("In App Notice - Reply & Close", {
      campaignId: notice.attributes.campaignId,
      contentfulEntryName: get(this, "contentfulEntry.attributes.name"),
      contentfulEntryId: notice.attributes.contentfulEntryId,
    })
  }

  replyAndCloseWithEmoji(emoji) {
    let notice = get(this, "notice")
    set(this, "isVisible", false)
    analytics.track("In App Notice - Reply & Close With Emoji", {
      campaignId: notice.attributes.campaignId,
      emojiResponse: emoji,
      contentfulEntryName: get(this, "contentfulEntry.attributes.name"),
      contentfulEntryId: notice.attributes.contentfulEntryId,
    })
  }
}
